import script from "./multipleObjectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./multipleObjectInput.vue?vue&type=script&setup=true&lang=ts"

import "./multipleObjectInput.vue?vue&type=style&index=0&id=46aa7e4c&lang=scss"

const __exports__ = script;

export default __exports__